/// <amd-module name="Artifacts/Pypi/commands/Badge" />
import { getBadgeCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createBadgeCommand = getBadgeCommandCreator();
